<script>
import { mapState } from 'vuex';

export default {
    name: "list",
    data() {
        return {
            // list: [
            //     {
            //         image: require('@/assets/images/study_list_01.jpg'),
            //         name: 'MBA (Top-up)',
            //         logo: require('@/assets/images/study_list_logo_01.jpg'),
            //         id: 0
            //     },
            //     {
            //         image: require('@/assets/images/study_list_01.jpg'),
            //         name: 'MBA (Top-up)',
            //         logo: require('@/assets/images/study_list_logo_01.jpg'),
            //         id: 0
            //     },
            //     {
            //         image: require('@/assets/images/study_list_01.jpg'),
            //         name: 'MBA (Top-up)',
            //         logo: require('@/assets/images/study_list_logo_01.jpg'),
            //         id: 0
            //     },
            //     {
            //         image: require('@/assets/images/study_list_01.jpg'),
            //         name: 'MBA (Top-up)',
            //         logo: require('@/assets/images/study_list_logo_01.jpg'),
            //         id: 0
            //     },
            // ]
        };
    },
    computed: {
        ...mapState(['studyList']),
    },
    components: {
        
    },
    mounted() {
        this.$store.dispatch('getList', {
            category_id: this.$route.query.id
        });
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="list layout_main flex flex_wrap justify_between">
        <router-link class="item" v-for="(item, index) in studyList" :key="index" :to="`/study/detail?id=${item.id}`">
            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
            <div class="name">{{ item.name }}</div>
            <img :src="item.logo" alt="" class="logo" v-if="item.logo"/>
            <div class="btn flex_center">Learn More</div>
        </router-link>
    </div>
</template>

<style scoped lang="scss">
.list{
    padding: .8rem 0;
    gap: .8rem 0;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
    }
    .item{
        width: 5.9rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .cover{
            height: 2.8rem;
            margin-bottom: .3rem;
            @media only screen and (max-width: 750px) {
                width: 100%;
                height: 2.4rem;
            }
        }
        .name{
            font-size: .32rem;
            font-weight: 600;
            margin-bottom: .2rem;
            line-height: 1.4;
        }
        .logo{
            height: .7rem;
            margin-bottom: .2rem;
        }
        .btn{
            font-size: .16rem;
            font-weight: 600;
            width: 1.5rem;
            height: .4rem;
            border-radius: .4rem;
            color: #00c2ff;
            background: var(--background-color);
            // cursor: pointer;
            line-height: 2;
            @media only screen and (max-width: 750px) {
                font-size: .32rem;
                width: 2.4rem;
                height: .46rem;
            }
        }
    }
}
</style>